import * as React from "react";
import * as classNames from "classnames";
import { ReactNode } from "react";

interface IAlertProps {
    type: AlertType
}

interface IAlertState {
    expanded: boolean
}

export enum AlertType {
    Info = 0,
    Warning = 1,
    Danger = 2,
    Success = 3
}

export default class Alert extends React.PureComponent<IAlertProps, IAlertState> {
    constructor(props: IAlertProps) {
        super(props);
        this.state = {
            expanded: false
        }
        this.handleClick = this.handleClick.bind(this);
    }

    private handleClick() {
        this.setState({ expanded: !this.state.expanded });
    }

    public render(): ReactNode {
        let className: string = classNames(
            "alert",
            {
                "alert-info": this.props.type == AlertType.Info,
                "alert-warning": this.props.type == AlertType.Warning,
                "alert-danger": this.props.type == AlertType.Danger,
                "alert-success": this.props.type == AlertType.Success,
            }
        );
        return (
            <div className={className} onClick={this.handleClick}>
                <div className="text">
                    {this.props.children}
                </div>
            </div>
        );
    }
}
